import { render } from "./UpdateMessage.vue?vue&type=template&id=9ec45840"
import script from "./UpdateMessage.vue?vue&type=script&lang=js"
export * from "./UpdateMessage.vue?vue&type=script&lang=js"
script.render = render

export default script